import {Row} from './fila'
export class TableHeader {
    cantidadSeleccionados: number;
    allSelected: boolean;

    constructor(){
        this.cantidadSeleccionados = 0;
        this.allSelected = false;
    }

    seleccionarTodos( filas: Array<Row>){
        this.allSelected ? this.cantidadSeleccionados = filas.length: this.cantidadSeleccionados = 0;

        for(var i: number = 0, len = filas.length; i < len;i++){
            filas[i].seleccionado = this.allSelected;
        }
    }

    verificarSeleccion(seleccionado: boolean, cantidadFilasTotal: number){
        if(seleccionado){
            this.cantidadSeleccionados++;
        }else{
            this.cantidadSeleccionados--;
        }

        if(cantidadFilasTotal == this.cantidadSeleccionados){
            this.allSelected = true;
        }else{
            this.allSelected = false;
        }
    }
}